// @flow

export const groupIdGlobal = 20152;
export const groupIdSitoumus2050 = 20143;

export const vocAgenda2030 = 31802;
export const vocUserType = 33488;
export const vocMainCom = 31800; //päätavoitteen kategoriat
export const vocOtherCom = 31801;
export const vocComType = 33552;
export const vocOrgSize = 33547;

export const vocCommitmentType = 33552;

export const catCompany = 33497; // Yritys-kategoria
export const catPerson = 33545; // Yksityishenkilö-kategoria
// Kaikki organisaatiotyypit
export const allTypes = [
  "33497", // Yritys
  "33496", // Varhaiskasvatusyksikkö (mm. Päiväkoti, perhepäivähoito, kerho)
  "33501", // Työmarkkinajärjestö
  "33500", // Puolue tai muu poliittinen järjestö
  "33511", // Muu hallinto
  "33543", // Muu
  "33510", // Ministeriö
  "33491", // Maakunta
  "33505", // Maakunnan ruokapalvelu
  "33503", // Kunnan ruokapalvelu
  "33493", // Koulu/oppilaitos (perusasteen koulutus)
  "38128", // Koulu/oppilaitos (2. aste, lukio, ammatillinen koulutus, vapaa sivistystyö)
  "33492", // Kirkko, seurakunta
  "33502", // Kaupunki, kunta
  "33499", // Kansalaisjärjestö, yhdistys tai säätiö
  "33498", // Elinkeinoelämän etujärjestö
  "33494", // Ammattikorkeakoulut ja yliopistot (korkea-aste)
  "593301" // Muu julkinen organisaatio
];

export const COMMITMENTS_FOLDER_ID = 31788;
export const GREEN_DEAL_COMMITMENTS_FOLDER_ID = 31790;
export const NUTRITION_COMMITMENTS_FOLDER_ID = 31792;
export const MATERIAL_COMMITMENTS_FOLDER_ID = 599788;

export const ADMIN_USER_ID = 20156;
export const GUEST_USER_ID = 20120;
export const COMMITMENT_DDM_STRUCTURE_KEY = "31796";
export const COMMITMENT_DDM_TEMPLATE_KEY = "33557";

export const COMPANY_ID = 20116;
export const WEB_CONTENT_ARTICLE_ORGANIZATION_NAME_EXPANDO_FIELD_NAME =
  "Organization name";

export const icon_path_commitment2050_goals = `/documents/${groupIdGlobal}/36219/`;
export const icon_path_agenda2030_goal = `/documents/${groupIdGlobal}/36026`;
export const icon_path_report_progress = `/documents/${groupIdGlobal}/31403`;

export type COMMITMENT_STATUS = -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

// var STATUS_ANY = -1;
// var STATUS_APPROVED = 0;
// var STATUS_DENIED = 4;
// var STATUS_DRAFT = 2;
// var STATUS_EXPIRED = 3;
// var STATUS_IN_TRASH = 8;
// var STATUS_INACTIVE = 5;
// var STATUS_INCOMPLETE = 6;
// var STATUS_PENDING = 1;
// var STATUS_SCHEDULED = 7;



// WEBPACK FOOTER //
// ./src/constants/constants.js